export default __webpack_public_path__ + "static/media/stamp.64212787.png";